


































































































































































































import {Component, Prop, Mixins} from 'vue-property-decorator'
import ContractDappCellRender from '@/components/render/ContractDappCellRender.vue'
import {$} from '@/facade'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {OrbitProjectCollection} from '@/model/collection/OrbitProjectCollection'

@Component({
  components: {
    ContractDappCellRender,
  },
  computed: {
    $() {
      return $
    },
  },
})
export default class OrbitRoundScrollableTable extends Mixins(MixinScreenSize) {
  @Prop({type: OrbitProjectCollection, required: true})
  orbitProjectCollection!: OrbitProjectCollection
  @Prop({type: Object, required: true}) transactionCountMap!: Record<
    string,
    {
      total: string
      your: string
    }
  >

  copyToClipboard(scriptHash: string) {
    this.$utils.copyToClipboard(scriptHash)
    this.$toast.info('system.info.copiedToClipboard')
  }

  formattedHash(hash: string) {
    if (!hash) return
    if (!this.isLessThanTablet) return hash

    return `${hash.slice(0, 5)}...${hash.slice(-5)}`
  }

  getTotalTxs(idOrbitProjectPk: number | undefined): string {
    if (!idOrbitProjectPk) return 'N/A'
    return this.transactionCountMap[idOrbitProjectPk]?.total ?? 'N/A'
  }

  getYourTxs(idOrbitProjectPk: number | undefined): string {
    if (!idOrbitProjectPk) return 'N/A'
    return this.transactionCountMap[idOrbitProjectPk]?.your ?? 'N/A'
  }
}
